import React from "react";
import styles from "./index.module.scss";
import Tag from "./Tag";
export default class MultiTextAddNew extends React.Component {
    static defaultProps = {
        values: [],
        separators: [","],
        format: (text) => text,
    };
    handlePaste = (event) => {
        event.stopPropagation();
        const separatedList = event.clipboardData.getData("Text").split(",");
        const newValues = [];
        for (const element of separatedList) {
            if (this.props.values.length + 1 !== this.props.limit) {
                const validatedText = this.props.format(element);
                if (validatedText !== undefined) {
                    newValues.push(validatedText);
                }
            }
        }
        const { values } = this.props;
        this.props.onChange(this.props.name, [...values, ...newValues]);
        event.target.value = "";
        event.preventDefault();
    };
    handleChange = (event) => {
        event.stopPropagation();
        const values = this.props.values || [];
        const text = event.target.value;
        if (event.key === "Backspace" && values.length > 0 && !text) {
            this.props.onChange(this.props.name, values.slice(0, -1));
        }
        if (text && values.length !== this.props.limit) {
            const validatedText = this.props.format(text);
            if (validatedText !== undefined) {
                this.props.onChange(this.props.name, [...values, validatedText]);
                event.target.value = "";
                event.preventDefault();
            }
        }
        if (text &&
            this.props.separators.includes(event.key) &&
            values.length !== this.props.limit) {
            const validatedText = this.props.format(text);
            if (validatedText !== undefined) {
                this.props.onChange(this.props.name, [...values, validatedText]);
                event.target.value = "";
                event.preventDefault();
            }
        }
    };
    onTagRemove = (text) => {
        this.props.onChange(this.props.name, this.props.values.filter((tag) => tag !== text));
    };
    render() {
        return (React.createElement("div", { className: `${styles.container} 
                ${this.props.disabled ? styles.disabled : ""}
                ${this.props.error ? styles.error : ""}
                ` },
            (this.props.values || []).map((tag, index) => (React.createElement(Tag, { key: `${tag}-${index}`, text: tag, remove: this.onTagRemove }))),
            React.createElement("input", { className: `
                    ${styles.input} 
                    ${this.props.error ? styles.error : ""}
                    `, type: "text", name: this.props.name, placeholder: this.props.placeHolder, onKeyDown: this.handleChange, disabled: this.props.disabled, onPaste: this.handlePaste, onMouseDown: this.handleChange, onMouseOut: this.handleChange, onBlur: this.handleChange })));
    }
}
